import React from "react";
import classNames from "classnames";
import LandingTypography from "../../../landingPage/pages/Homepage/components/LandingTypography";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";
import AuthPageHero from "../components/AuthPageHero";
import AuthGdprFooter from "../components/AuthGdprFooter";

function AuthPageLayout({ title, subtitle, children, footer }) {
  const isDesktop = useIsDesktop();

  return (
    <LandingTypography>
      <div
        className={classNames("min-h-screen", {
          "grid grid-cols-2 p-6 gap-12": isDesktop,
          "py-6 px-4": !isDesktop
        })}
      >
        <div
          className={classNames(
            "max-w-500 justify-self-center flex flex-col justify-between",
            { "mt-24 mb-15": isDesktop }
          )}
        >
          <div>
            <h1
              className={
                "text-4xl.1 font-semibold line-height-120 text-black mb-3"
              }
            >
              {title}
            </h1>
            {subtitle ? (
              typeof subtitle === "string" ? (
                <p className={"text-xs line-height-160 text-black-8 mb-10"}>
                  {subtitle}
                </p>
              ) : (
                <div className={"mb-10"}>{subtitle}</div>
              )
            ) : null}
            {children}
          </div>
          {footer || <AuthGdprFooter />}
        </div>
        {isDesktop ? <AuthPageHero /> : null}
      </div>
    </LandingTypography>
  );
}

export default AuthPageLayout;
